// Define all icon types
export const ICON_TYPES = {
  EVENT1: "event1",
  EVENT2: "event2",
  EVENT3: "event3",
  EVENT4: "event4",
  EVENT5: "event5",
  EVENT6: "event6",
};
